// @flow
import * as React from 'react';

export function AiLogo() {
    return (
        <div>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                 xmlns="http://www.w3.org/2000/svg">

                <defs>
                    <linearGradient id="simmsBlue" x1="0" y1="0" x2="24" y2="24">
                        <stop offset="0%" stopColor="#3B82F6"/>
                        <stop offset="100%" stopColor="#1F3A8A"/>
                    </linearGradient>
                </defs>

                {/*Head*/}
                <rect x="4" y="7" width="16" height="11" rx="3"
                      stroke="url(#simmsBlue)" strokeWidth="1.8"/>

                {/*Eyes*/}
                <circle cx="9" cy="12.5" r="1.2" fill="#1F3A8A">
                    <animate attributeName="ry"
                             values="1.2;0.1;1.2"
                             dur="4s"
                             repeatCount="indefinite"
                             keyTimes="0;0.05;0.1"
                    />
                </circle>

                <circle cx="15" cy="12.5" r="1.2" fill="#1F3A8A">
                    <animate attributeName="ry"
                             values="1.2;0.1;1.2"
                             dur="4s"
                             repeatCount="indefinite"
                             keyTimes="0;0.05;0.1"
                    />
                </circle>

                {/*Data Mouth*/}
                <line x1="9" y1="16" x2="15" y2="16"
                      stroke="#3B82F6"
                      strokeWidth="1.5"
                      strokeLinecap="round"/>

                {/*Antenna*/}
                <line x1="12" y1="4" x2="12" y2="7"
                      stroke="url(#simmsBlue)"
                      strokeWidth="1.8"
                      strokeLinecap="round"/>

                <circle cx="12" cy="3" r="1.2" fill="#3B82F6">
                    <animate attributeName="opacity"
                             values="1;0.3;1"
                             dur="1.8s"
                             repeatCount="indefinite"/>
                </circle>

            </svg>
        </div>
    );
};